import React from 'react';

export const DeleteProjectActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User.name} removed the {props.CustomEventData ? props.CustomEventData.title : ""} Project.
</p>;



